import React, { useState } from 'react';
import { Col, Row } from "react-bootstrap";
import { ArrowRightCircle } from 'react-bootstrap-icons'

export default function Role({ item }) {

  const [showRoleDescription, setShowRoleDescription] = useState(false) // State to manage description visibility
  const toggleRoleDescription = () => setShowRoleDescription(!showRoleDescription) // Toggle description visibility

  return (
    <>
      <Row>
        <Col>
          <h1 className='golden-text mb-2' onClick={toggleRoleDescription} style={{ cursor: 'pointer' }}>{item?.meetingRole.name} <ArrowRightCircle className='arrowcircle' /> </h1>
        </Col>
      </Row>
      <Row>
        <Col>
          <div dangerouslySetInnerHTML={{ __html: item?.meetingRole.description }} style={{ display: showRoleDescription ? 'block' : 'none' }}></div>
        </Col>
      </Row>
    </>
  );
}